import ntactlogo from "../../assets/Ntact.png";
import { useState } from "react";
import Usa from "../../assets/UsaFlag.png";

const UserDetails = ({
  selectedCompany,
  employee,
  setScreen,
  email,
  setEmail,
  mobile,
  setMobile,
  gender,
  register,
  setgender,
  createuser,
}) => {
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [genderError, setGenderError] = useState("");

  const handleProceed = () => {
    let isValid = true;

    // EMAIL VALIDATION
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Enter a valid email");
      isValid = false;
    } else {
      setEmailError("");
    }

    // MOBILE VALIDATION
    const mobileRegex = /^[0-9]{10}$/;
    if (!mobile.trim()) {
      setMobileError("Mobile number is required");
      isValid = false;
    } else if (!mobileRegex.test(mobile)) {
      setMobileError("Enter a valid 10-digit mobile number");
      isValid = false;
    } else {
      setMobileError("");
    }

    // GENDER VALIDATION
    if (!gender.trim()) {
      setGenderError("Gender is required");
      isValid = false;
    } else if (!["M", "F"].includes(gender.toUpperCase())) {
      setGenderError("Gender must be 'M' or 'F'");
      isValid = false;
    } else {
      setGenderError("");
    }

    if (isValid) {
      createuser();
      // setScreen(1);
    }
  };

  return (
    <div
      className="w-auto sm:w-[600px] p-6 text-center bg-white"
      style={{
        borderRadius: "12.75px",
        boxShadow: "0 0 4px 0 rgba(179, 67, 67, 0.5)",
        borderColor: "rgba(179, 67, 67, 0.2)",
      }}
    >
      {/* LOGO */}
      <div className="flex justify-center mb-4">
        <img src={ntactlogo} alt="NTact Logo" className="w-24" />
      </div>

      <h2 className="text-lg font-semibold text-[#0A0A0A]">
        Welcome, {employee ? `${employee.firstname} ${employee.lastname}` : ""}
      </h2>

      <p className="text-sm text-gray-500 mb-4">
        {selectedCompany?.name} • ID: {employee?.empid}
      </p>

      {/* EMAIL */}
      <div className="text-left mb-3">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Email
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setEmailError("");
          }}
          placeholder="Enter email"
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-black"
        />
        {emailError && (
          <p className="text-red-600 text-xs mt-1">{emailError}</p>
        )}
      </div>

      {/* MOBILE NUMBER */}
      <div className="text-left mb-3">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Mobile Number
        </label>

        <div className="flex items-center w-full">
          {/* USA FLAG + +1 */}
          <div className="flex items-center gap-1 px-3 py-2 border border-gray-300 rounded-l bg-gray-50">
            <img src={Usa} style={{ width: "22px" }} alt="USA Flag" />
            <span className="text-sm">+1</span>
          </div>

          {/* MOBILE INPUT */}
          <input
            type="tel"
            maxLength={10}
            value={mobile}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "");
              setMobile(value);
              setMobileError("");
            }}
            placeholder="Enter mobile number"
            className="w-full p-2 border border-gray-300 rounded-r focus:outline-none focus:ring-1 focus:ring-black"
          />
        </div>

        {mobileError && (
          <p className="text-red-600 text-xs mt-1">{mobileError}</p>
        )}
      </div>

 {/* GENDER DROPDOWN */}
<div className="text-left mb-6">
  <label className="block text-sm font-medium text-gray-700 mb-1">
    Gender
  </label>

  <select
    value={gender}
    onChange={(e) => {
      setgender(e.target.value);  // value will be "M" or "F"
      setGenderError("");
    }}
    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-black"
  >
    <option value="">Select Gender</option>
    <option value="M">Male</option>
    <option value="F">Female</option>
  </select>

  {genderError && (
    <p className="text-red-600 text-xs mt-1">{genderError}</p>
  )}
</div>


      {/* BUTTON */}
    <button
  className={`w-full min-h-[50px] text-white font-medium py-2 px-4 rounded
    ${register ? "bg-gray-400 cursor-not-allowed" : "bg-[#0A0A0A] hover:bg-gray-800"}
  `}
  disabled={register}
  onClick={register ? null : handleProceed}
>
  {register ? "Processing..." : "Proceed To Facial Recognition"}
</button>

    </div>
  );
};

export default UserDetails;
